"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _alertModal = _interopRequireDefault(require("../alertModal"));

var _AppBar = _interopRequireDefault(require("./AppBar"));

var _Drawer = _interopRequireDefault(require("./Drawer"));

var _loader = _interopRequireDefault(require("../loader"));

var _Hidden = _interopRequireDefault(require("@material-ui/core/Hidden"));

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var drawerWidth = 240;

var styles = function styles(theme) {
  var _component, _content;

  return {
    root: {
      flexGrow: 1,
      zIndex: 1,
      overflow: 'hidden',
      position: 'relative',
      display: 'flex',
      width: '100%',
      height: '100vh'
    },
    component: (_component = {
      overflow: 'auto'
    }, _defineProperty(_component, theme.breakpoints.down('sm'), {
      padding: theme.spacing(1.5)
    }), _defineProperty(_component, theme.breakpoints.up('md'), {
      padding: theme.spacing(3)
    }), _component),
    content: (_content = {
      flexGrow: 1,
      overflow: 'auto'
    }, _defineProperty(_content, theme.breakpoints.down('sm'), {
      padding: theme.spacing(1.5)
    }), _defineProperty(_content, theme.breakpoints.up('md'), {
      padding: theme.spacing(3)
    }), _content),
    fillDiv: theme.mixins.toolbar
  };
};

var SideMenu =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SideMenu, _React$Component);

  function SideMenu(props) {
    var _this;

    _classCallCheck(this, SideMenu);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SideMenu).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleDrawerToggle", function () {
      _this.setState(function (state) {
        return {
          mobileOpen: !state.mobileOpen
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleItemClick", function (component) {
      _this.props.handleItemClick(component);

      _this.handleDrawerToggle();
    });

    _defineProperty(_assertThisInitialized(_this), "toggleAlertModal", function () {
      _this.setState(function (prevState) {
        return {
          alertModal: !prevState.alertModal
        };
      });
    });

    _this.state = {
      alertModal: false,
      mobileOpen: false
    };
    return _this;
  }

  _createClass(SideMenu, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          component = _this$props.component,
          currentPath = _this$props.currentPath,
          items = _this$props.items,
          handleTabClick = _this$props.handleTabClick,
          loading = _this$props.loading,
          logo = _this$props.logo,
          tabs = _this$props.tabs,
          title = _this$props.title;
      var alertModal = this.state.alertModal;
      return _react["default"].createElement("div", {
        className: classes.root
      }, _react["default"].createElement(_alertModal["default"], {
        action: this.props.handleLogout,
        closeModal: this.toggleAlertModal,
        header: "\xBFQuieres cerrar sesi\xF3n?",
        open: alertModal,
        subh: "Si cierras sesi\xF3n, necesitar\xE1s la contrase\xF1a para volver a ingresar."
      }), _react["default"].createElement(_Hidden["default"], {
        mdUp: true
      }, _react["default"].createElement(_Drawer["default"], {
        currentPath: currentPath,
        handleItemClick: this.handleItemClick,
        items: items,
        logo: logo,
        onClose: this.handleDrawerToggle,
        open: this.state.mobileOpen,
        variant: "temporary"
      })), _react["default"].createElement(_Hidden["default"], {
        smDown: true,
        implementation: "css"
      }, _react["default"].createElement(_Drawer["default"], {
        currentPath: currentPath,
        handleItemClick: this.handleItemClick,
        items: items,
        logo: logo,
        open: true,
        variant: "permanent"
      })), _react["default"].createElement("div", {
        className: classes.content
      }, _react["default"].createElement(_AppBar["default"], {
        handleTabClick: handleTabClick,
        logout: this.toggleAlertModal,
        openDrawer: this.handleDrawerToggle,
        tabs: tabs,
        title: title
      }), _react["default"].createElement("div", {
        className: classes.fillDiv
      }), _react["default"].createElement("div", null, loading ? _react["default"].createElement(_loader["default"], null) : component)));
    }
  }]);

  return SideMenu;
}(_react["default"].Component);

SideMenu.propTypes = {
  classes: _propTypes["default"].object.isRequired,
  theme: _propTypes["default"].object.isRequired
};

var _default = (0, _styles.withStyles)(styles, {
  withTheme: true
})(SideMenu);

exports["default"] = _default;